import React, { useState, useEffect,useCallback } from "react";
import List from "../../../../styledComponents/Table/List";
import menuIcon from "../../../../../assets/images/DeathModuleNew/Menu.png";
import plaidIcon from "../../../../../assets/images/budget/plaidlogo.png";
import { Icon, Table } from "antd";
import { debounce } from "lodash";
import moment from "moment";
import BUDGET_API from "../../../../../apis/budget.api";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import swal from "sweetalert";

export const AllAccount = (props) => {
  console.log("props allaccount", props);
  const [dropdown, setDropdown] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [allAccountTransactions, setAllAccountTransactions] = useState([]);
  const [cachedData, setCachedData] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchTransactions, setSearchTransactions]=useState(null);
  // const totalAmount =
  //   props.transactions &&
  //   props.transactions.allAccount &&
  //   props.transactions.allAccount.reduce((total, item) => {
  //     return total + item.amount;
  //   }, 0);
  // const totalAmount =
  //   props.transactions &&
  //   props.transactions.allAccount &&
  //   props.transactions.allAccount.reduce((total, item) => {
  //     // Check if item.categoryFromPlaid is not null
  //     if (item.categoryFromPlaid !== null) {
  //       return total + item.amount;
  //     } else {
  //       return total;
  //     }
  //   }, 0);

  // for new api in porgress
  // const getAllTransactions = async (page, pageSize) => {
  //   try {
  //     setLoading(true);
  //     const key = `${page}-${pageSize}`;

  //     // Check if data for this page and limit already exists in the cache
  //     if (cachedData[key]) {
  //       setAllAccountTransactions(cachedData[key]);
  //       setLoading(false);
  //       return;
  //     }

  //     // Call API to fetch data
  //     const data = await BUDGET_API.fetchAllTransaction(page, pageSize);

  //     if (data && data.data) {
  //       setTotalPages(data.data.totalPages);
  //       setCurrentPage(page);

  //       const sortedData = data.data.transactions.sort((a, b) => {
  //         const dateA = new Date(a.date || "");
  //         const dateB = new Date(b.date || "");
  //         return dateB - dateA;
  //       });

  //       const allAccount = sortedData.map((item) => {
  //         if (item.amount && item.typeOfTransaction === null) {
  //           item.amount = -1 * item.amount;
  //         }
  //         return item;
  //       });

  //       // Update state and cache
  //       setAllAccountTransactions(allAccount);
  //       setCachedData((prev) => ({
  //         ...prev,
  //         [key]: allAccount,
  //       }));
  //     }
  //   } catch (error) {
  //     console.error("Error fetching transactions:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   getAllTransactions(1, limit);
  // }, [limit]);

  // const handleTableChange = (page, pageSize) => {
  //   console.log("pageSize",pageSize,page)
  //   if (pageSize !== limit) {
  //     setLimit(pageSize);
  //     setCurrentPage(1);
  //     getAllTransactions(1, pageSize);
  //   } else {
  //     getAllTransactions(page, pageSize);
  //   }
  // };
  // Debounced function for API call
    const handleSearch = useCallback(
      debounce(async (query) => {
        console.log("Search Query before filtering Transaction:", query);
    
        if (!query) {
          // await getTransactions();
          // setUpdateState((prev) => !prev);
          return;
        }
    
        setLoading(true);
        try {
          let queryParam = `search=${query}&page=1`;
          let initialResponse = await BUDGET_API.fetchFilterTransaction(queryParam);
    
          if (!initialResponse || initialResponse.status !== 200 || !initialResponse.data) {
            swal("Error", "Failed to fetch data", "error");
            return;
          }
    
          const totalPages = initialResponse.data.totalPages;
          let allTransactions = initialResponse.data.transactions || [];
    
          // Prepare API requests for remaining pages
          const pageRequests = [];
          for (let page = 2; page <= totalPages; page++) {
            let paginatedQueryParam = `search=${query}&page=${page}`;
            pageRequests.push(BUDGET_API.fetchFilterTransaction(paginatedQueryParam));
          }
    
          try {
            // Fetch all pages in parallel
            const responses = await Promise.all(pageRequests);
    
            // Combine results
            responses.forEach((response) => {
              if (response && response.status === 200 && response.data.transactions) {
                allTransactions = allTransactions.concat(response.data.transactions);
              }
            });
    
            // Process data into categories
            const allAccount = allTransactions;
    
            const checkingSavingData = allAccount.filter(
              (item) =>
                (item.accountType === "checking" || item.accountType === "savings") &&
                item.categoryFromPlaid !== null
            );
    
            const creditData = allAccount.filter(
              (item) =>
                item.accountType === "credit card" && item.categoryFromPlaid !== null
            );
    
            const investmentData = allAccount.filter(
              (item) =>
                ![
                  "checking",
                  "savings",
                  "credit card",
                  "student",
                  "loan",
                  "auto",
                  "business",
                  "commercial",
                  "construction",
                  "consumer",
                  "overdraft",
                  "home equity",
                  "line of credit",
                  "mortgage",
                ].includes(item.accountType) && item.categoryFromPlaid !== null
            );
    
            const studentData = allAccount.filter(
              (item) =>
                [
                  "student",
                  "mortgage",
                  "loan",
                  "auto",
                  "business",
                  "commercial",
                  "construction",
                  "consumer",
                  "overdraft",
                  "home equity",
                  "line of credit",
                ].includes(item.accountType) && item.categoryFromPlaid !== null
            );
    
            const cashData = allAccount.filter(
              (item) => item.paidUsing === "Cash" && item.categoryFromPlaid !== null
            );
    
            const nullCategoryDataNullCategory = allAccount.filter(
              (item) => item.categoryFromPlaid === null
            );
    
            const resultObject = {
              allAccount,
              checkingSavingData,
              creditData,
              investmentData,
              studentData,
              nullCategoryDataNullCategory,
              cashData,
            };
    
            console.log("Final Search Result Object:", resultObject);
            setSearchTransactions(resultObject);
          } catch (error) {
            console.error("Error fetching all pages:", error);
            swal("Error", "Failed to fetch search transactions", "error");
          }
        } catch (error) {
          console.log(error);
        }
        setLoading(false);
      }, 500), // Debounce: 500ms delay
      []
    );
    useEffect(() => {
      if (props.filterData && props.searchQuery) {
        if(props.searchQuery!==""){
          handleSearch(props.searchQuery);
        }else{
          setSearchTransactions(null);
        }
      }
    }, [props.state, props.searchQuery, props.transactions]);

  const totalAmount =
    props.banksData &&
    props.banksData.reduce((total, item) => {
      // Check if the balance is not null and can be parsed to a number
      const balance = parseFloat(item.balance);
      return total + (isNaN(balance) ? 0 : balance);
    }, 0);

  console.log("Total Amount:", totalAmount);
  const [sortOrder, setSortOrder] = useState("asc"); // Initialize sort order state
  const handleSorting = () => {
    // Toggle sort order between 'asc' and 'desc'
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newSortOrder);
  };

  const cols = [
    {
      title: "Date",
      dataIndex: "date",
      // sorter: (a, b) => a["date"] > b["date"],
      sorter: (a, b) => (a.date || "").localeCompare(b.date || ""),
      // render: (record) =>
      //   record ? moment.utc(record).format("MM-DD-YYYY") : "N/A",
      render: (fileName, record) => {
        return record.pending ? (
          <div
            style={{
              background: "#09A84D",
              padding: "4px",
              color: "white",
              display: "flex",
              justifyContent: "center",
              borderRadius: "4px",
              fontWeight: "bold",
            }}
          >
            Pending
          </div>
        ) : record.date ? (
          moment.utc(record.date).format("MM-DD-YYYY")
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Item",
      dataIndex: "itemName",
      // sorter: (a, b) => a["itemName"] > b["itemName"],
      sorter: (a, b) => (a.itemName || "").localeCompare(b.itemName || ""),
      render: (fileName, record) => {
        return record.itemName ? (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <img
              style={{ borderRadius: "50%" }}
              height={34}
              width={34}
              src={record.itemLogo ? record.itemLogo : plaidIcon}
            ></img>
            <div>{record.itemName}</div>
          </div>
        ) : (
          "N/A"
        );
      },
    },

    {
      title: "Category",
      dataIndex: "categoryFromPlaid",
      sorter: (a, b) =>
        (a.categoryFromPlaid || "").localeCompare(b.categoryFromPlaid || ""),
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        return record.categoryFromPlaid ? (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              props.handleOpen();
              handleFormDataUpdate(record);
            }}
          >
            <div>{record.categoryFromPlaid}</div>
            {record.subCategory && (
              <span style={{ color: "black" }}>({record.subCategory})</span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => {
        const amountA = parseFloat(a.amount);
        const amountB = parseFloat(b.amount);
        // Toggle sorting order directly
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (fileName, record) => (
        <div
          style={{
            width: "100%",
            fontWeight: "bold",
            color:
              record.typeOfTransaction === "Expense" || record.amount < 0
                ? "black"
                : "#00A27B",
          }}
        >
          {record.amount
            ? !isNaN(record.amount)
              ? `${
                  "$" +
                  (record.typeOfTransaction === "Expense"
                    ? record.amount < 0
                      ? record.amount.toFixed(2) // Keep negative if already negative
                      : (record.amount * -1).toFixed(2) // Otherwise, make negative
                    : record.typeOfTransaction === "Income"
                    ? record.amount > 0
                      ? record.amount.toFixed(2) // Keep positive if already positive
                      : (record.amount * -1).toFixed(2) // Otherwise, make positive
                    : record.amount < 0
                    ? record.amount.toFixed(2) // If amount is negative and no type, show as positive
                    : record.amount.toFixed(2)
                  ) // If amount is positive and no type, show as is
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }`
              : "N/A"
            : "N/A"}
        </div>
      ),
    },
    {
      title: "Bank",
      dataIndex: "bankName",
      // sorter: (a, b) => a["bankName"] > b["bankName"],
      sorter: (a, b) => (a.bankName || "").localeCompare(b.bankName || ""),
      render: (fileName, record) => {
        return record.bankName ? (
          <div>
            <div>
              {record.accountName ? `${record.accountName}` : record.bankName}
            </div>
            {record.accountType && (
              <span style={{ color: "black" }}>{record.accountType}</span>
            )}
          </div>
        ) : record.paidUsing == "Cash" ? (
          "Cash"
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Rule Applied",
      dataIndex: "ruleId",
      sorter: (a, b) => (a.ruleId || "").localeCompare(b.ruleId || ""),
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Notes",
      dataIndex: "notes",
      sorter: (a, b) => (a.notes || "").localeCompare(b.notes || ""),
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Action",
      render: (record, index) => {
        return (
          <React.Fragment>
            <div style={{ display: "flex" }} key={index}>
              <div
                onClick={() => {
                  setSelectedItemId(record.id);
                  setDropdown(!dropdown);
                }}
                style={{
                  cursor: "pointer",
                  marginRight: "1rem",
                  padding: "0px 16px",
                  width: "5px",
                }}
              >
                <img src={menuIcon} alt="menuIcon" height={15} width={4}></img>{" "}
              </div>
              {dropdown && selectedItemId === record.id && (
                <React.Fragment>
                  <div
                    onClick={() => {
                      setDropdown(false);
                    }}
                    className=""
                    style={{
                      position: "fixed",
                      width: "100vw",
                      height: "100vh",
                      background: "black",
                      opacity: "0.1",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                      zIndex: "999",
                    }}
                  ></div>

                  <div class="dropdown" style={{ zIndex: "9999" }}>
                    <ul className="dropdownul">
                      <li
                        className="liHover"
                        onClick={() => {
                          setDropdown(false);
                          props.handleHistoryOpen(record.id);
                        }}
                      >
                        History
                      </li>
                      <li
                        className="liHover"
                        style={{opacity :record.ruleId !== null ? "0.3" : "1", cursor: record.ruleId!==null ? "not-allowed" : "pointer", pointerEvents: record.ruleId!==null ? "none" : "",}}
                        onClick={() => {
                          setDropdown(false);
                          props.handleOpen();
                          handleFormDataUpdate(record);
                        }}
                      >
                        Update
                      </li>

                      <li
                        className="liHover"
                        onClick={() => {
                          setDropdown(false);
                          props.deleteTransaction(record.id);
                        }}
                      >
                        Delete
                      </li>
                    </ul>
                  </div>
                </React.Fragment>
              )}{" "}
            </div>
          </React.Fragment>
        );
      },
    },
  ];

  const handleFormDataUpdate = (data) => {
    props.handleUpdateFormData(data);
  };
  return (
    <div>
      {" "}
      <div className="subheading">
        All Accounts{" "}
        {/*<span className="subheading_amount">
          (${" "}
          {totalAmount
            ? `${totalAmount
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "0"}
          )
        </span> */}
      </div>
      <div className="tableContainer">
        <Table
          rowKey="id"
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: props.selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
              console.log("selectedRowKeys:", selectedRowKeys);
              console.log("selectedRows:", selectedRows);
              props.selectedRowsDataKeys(selectedRowKeys);
            },
          }}
          pagination={{
            showSizeChanger: true, // Show the page size changer
            pageSizeOptions: ["10", "20", "50", "100"], // Options for page size
            defaultPageSize: 10, // Default page size
          }}
          columns={cols}
          dataSource={
            searchTransactions
              ? searchTransactions.allAccount
              : props.transactions
              ? props.transactions.allAccount
              : []
          }
        />
        <NewLoader isLoading={loading}/>
        {/*table with new api
        <div style={{position:"relative"}}>
        <Table
          columns={cols}
          dataSource={allAccountTransactions && allAccountTransactions}
          pagination={{
            total: totalPages * limit,
            current: currentPage,
            onChange: handleTableChange,
            pageSizeOptions: ["10", "20", "50", "100"],
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSize: limit,
          }}
        />
        <NewLoader isLoading={loading}/>
        </div>*/}
        {/*  <List
          cols={cols}
          rows={
            props.filterData
              ? props.filterData
              : props.transactions
              ? props.transactions.allAccount
              : []
          }
          // rows={props.transactions && props.transactions.allAccount}
        /> */}
      </div>
    </div>
  );
};
